export default {
  computed: {
    situations () {
      return {
        regulationCheckManagement: 'regulation_check_management',
        postListManagement: 'post_list_management',
        featureManagement: 'feature_management',
        pictureManagement: 'picture_management',
        characterImageManagement: 'character_image_management',
        siteConfiguration: 'site_configuration',
        siteDesignConfiguration: 'site_design_configuration',
        tagManagement: 'tag_management',
        widgetManagement: 'widget_management',
        mediaPageManagement: 'media_page_management',
        htmlPageManagement: 'html_page_management',
        adminManagement: 'admin_management',
        writerManagement: 'writer_management',
        contributorManagement: 'contributor_management',
        expertManagement: 'expert_management',
        orderManagement: 'order_management',
        contactManagement: 'contact_management',
        footerLinkManagement: 'footer_link_management',
        mailMagazineMemberManagement: 'mail_magazine_member_management',
        exhibitManagement: 'exhibit_management',
        productManagement: 'product_management'
      }
    }
  }
}
